import { createContext, useContext, useEffect, useMemo } from "react";

const ThemeContext = createContext({ isDark: true, toggle: () => {}, set: () => {} });

export function ThemeProvider({ children }) {
  // Always dark mode - no state management needed
  
  useEffect(() => {
    // Always apply dark mode to the document
    const root = document.documentElement;
    root.classList.add("dark");
    try { 
      localStorage.setItem("theme", "dark"); 
    } catch {}
  }, []);

  const value = useMemo(() => ({
    isDark: true,
    toggle: () => {}, // No-op function since theme is permanently dark
    set: () => {}, // No-op function since theme is permanently dark
  }), []);

  return (
    <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>
  );
}

export function useTheme() {
  return useContext(ThemeContext);
}
